import type { AxiosInstance } from 'axios';
import type { AppConfig } from '@/types';
import baseAxios from '@/helpers/forms/axios';

interface BootstrapApi {
    fetchConfig: () => Promise<AppConfig>
}

export default (axios: AxiosInstance = baseAxios): BootstrapApi => ({
    fetchConfig: async (): Promise<AppConfig> => {
        const response = await axios.get<AppConfig>('/api/bootstrap');
        return response.data;
    },
});
